var metaInfo={
    title:"消费品加工制造_Movibot服务行业",
    keywords:"工业机器人_消费品加工制造_轻工业",
    description:"工业机器人为消费品加工制造行业提供搬运装箱、上下料、包装等服务，助力轻工业产业升级",
}

export default {
    metaInfo
  };


// WEBPACK FOOTER //
// ./src/data/metaInfo/2.js